import "./style.css";
import { Game } from "./game/Game";

const mount = document.querySelector<HTMLDivElement>("#app");

if (!mount) {
  throw new Error("Le div #app a pris une pause syndicale.");
}

const game = new Game(mount);
game.boot();

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("./sw.js", { scope: "./" });
  });
}
